// @ts-check
import { MARK_STYLE } from "../../../../../common/components/resultDisplay/option";

const commonHeaderProps = {
  numeric: false,
  disablePadding: true,
  display: true,
  useLink: false,
  useTooltip: false,
  useMark: false,
};

// table 的 headers
export const headers = {
  date: {
    label: "日期", // 用於 EnhancedTableHead
    id: "date", // 用於 EnhancedTableHead
    ...commonHeaderProps,
  },
  graphName: {
    label: "日誌",
    id: "graphName",
    ...commonHeaderProps,
  },
  // eventTypeName: 單個事件
  eventTypeName: {
    label: "事件類別",
    id: "eventTypeName",
    ...commonHeaderProps,
    display: false,
  },
  // eventTypesName: 組合過的事件字串
  eventTypesName: {
    label: "事件類別",
    id: "eventTypesName",
    ...commonHeaderProps,
  },
  eventTypeName2: {
    label: "其他事件類別",
    id: "eventTypeName2",
    ...commonHeaderProps,
    display: false,
  },
  persons: {
    label: "人物",
    id: "persons",
    ...commonHeaderProps,
    markStyle: MARK_STYLE.secondary.name,
    useMark: true,
  },
  personTagLabel: {
    label: "日記中人物名稱",
    id: "personTagLabel",
    ...commonHeaderProps,
    display: false,
  },
  content: {
    label: "日記內文",
    id: "content",
    ...commonHeaderProps,
    useMark: true,
    style: {
      minWidth: "200px",
      "&.MuiTableCell-root": { minWidth: "200px" },
    },
  },
};
